<template>
	<div id="copyright">{{ date }} Mutual Success Lighting Fixtures Inc.</div>
</template>

<script>
	export default{
		data(){
			return {
				date: new Date().getFullYear().toString()
			}
		},
		mounted(){
			relativeTo('nav', this.$el);
		}
	}
</script>


// WEBPACK FOOTER //
// Copyright.vue?2575122c